import { combineReducers } from 'redux';
import users from './users/UsersState';
import events from './events/EventAnalyticsState';
const trackReducer = combineReducers({
  users,
  events,
});

export default trackReducer;
